var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { useEntityDataHooks } from "./use-entity-data-hooks";
import { useEntityTypeDynamic } from "./use-entity-type-dynamic";
import { useEntityTypeAllQuery } from "./use-entity-type-all-query";
export var useEntityAll = function (entityTypeName) {
  var _a;
  var dynamicEntities = useEntityTypeDynamic();
  var dataHooks = useEntityDataHooks();
  var isDynamic = dynamicEntities.includes(entityTypeName);
  var query = useEntityTypeAllQuery(entityTypeName, isDynamic);
  if (isDynamic) {
    return __assign({}, query);
  }
  if (dataHooks[entityTypeName]) {
    return {
      data: (_a = {}, _a["all".concat(entityTypeName)] = query.items, _a),
      items: dataHooks[entityTypeName](),
      loading: false
    };
  }
  return {};
};